import ReactGA from "react-ga";

/**
 * 我的产品购买按钮点击
 */
const GAClickToBuy = label => {
    ReactGA.event({
        category: "navigation",
        action: "myproduct_buy",
        label,
    });
};

/**
 * 我的产品页面点击自动续费
 */
 const GAClickMyproductRenew = label => {
  ReactGA.event({
      category: "navigation",
      action: "myproduct_renew",
      label,
  });
};


/**
 * 点击开通vip按钮
 */
 const GAClickPersonalVip = label => {
  ReactGA.event({
      category: "navigation",
      action: "personal_vip",
      label,
  });
};


/**
 * 个人中心列表页的点击开通vip按钮
 */
 const GAClickPersonalListVip = label => {
  ReactGA.event({
      category: "navigation",
      action: "personal_viptabulation",
      label,
  });
};

/**
 * 开通vip页面立即购买按钮点击
 */
 const GAClickVipBuy = label => {
  ReactGA.event({
      category: "navigation",
      action: "vip_buy",
      label,
  });
};

export {
  GAClickToBuy,
  GAClickMyproductRenew,
  GAClickPersonalVip,
  GAClickVipBuy
};